module.exports = __webpack_public_path__ + "img/square-full.f64db227.svg";